"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pflip = void 0;
var type_system_1 = require("../../../type_system/index.js");
var papp_1 = require("../../papp.js");
var pfn_1 = require("../../pfn.js");
var phoist_1 = require("../../phoist.js");
function pflip(a, b, c) {
    return (0, phoist_1.phoist)((0, pfn_1.pfn)([
        (0, type_system_1.fn)([b, a], c),
        a,
        b
    ], c)(function (toFlip, _b, _a) {
        return (0, papp_1.papp)((0, papp_1.papp)(toFlip, _a), _b);
    }, "pflip"));
}
exports.pflip = pflip;
